export default "__VITE_ASSET__DPHZ3vas__"